<template>
    <div class="bo-company-selector-popup">
        <div
            class="modal-backdrop fade show"
            v-if="visible"
        ></div>
        <div
            v-if="visible"
            id="bo-company-selector-popup"
            class="modal bo-modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="bo-company-selector-popup"
            style="display: block"
        >
            <div
                class="modal-dialog modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title"></div>
                        <button
                            v-if="closable"
                            type="button"
                            class="close"
                            aria-label="Close"
                            @click="close"
                        >
                            <i class="icon-close"></i>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="company-selector-header">
                            <div class="title theme-primary-color">
                                {{ translations.company_selector || "Select Company" }}
                            </div>
                            <div class="prompt">{{ translations.select_company_prompt || "" }}</div>
                        </div>

                        <div
                            v-if="!loading && companies.length === 0"
                            class="company-selector-empty"
                        >
                            {{ translations.no_companies || "" }}
                        </div>
                        <div
                            v-else
                            class="company-list"
                        >
                            <button
                                v-for="company in companies"
                                :key="company.id"
                                type="button"
                                class="company-card theme-primary-color"
                                :class="{ selected: company.id === activeCompanyId }"
                                :disabled="switching"
                                @click="selectCompany(company)"
                            >
                                <span class="name">{{ company.name }}</span>
                                <span
                                    v-if="company.id === activeCompanyId"
                                    class="status-badge theme-primary-bg-color theme-secondary-color"
                                    >{{ generalTranslations.selected || "Selected" }}</span
                                >
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "bo-company-selector-popup",
    props: {
        siteLogoUrl: {
            type: String,
            default: "",
        },
        generalTranslations: {
            type: Object,
            default: () => ({}),
        },
        translations: {
            type: Object,
            default: () => ({}),
        },
        companySelectorUrl: {
            type: String,
            required: true,
        },
        companySelectorSwitchUrl: {
            type: String,
            required: true,
        },
        // True when the current user has no active company yet — the popup opens on
        // mount and cannot be dismissed until a company is chosen.
        forceOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            visible: false,
            loading: false,
            switching: false,
            companies: [],
            activeCompanyId: null,
        };
    },
    computed: {
        closable() {
            return !this.forceOpen || this.activeCompanyId !== null;
        },
    },
    mounted() {
        if (this.forceOpen) {
            this.open();
        }
    },
    methods: {
        open() {
            this.visible = true;
            this.fetchCompanies();
        },
        close() {
            if (!this.closable) {
                return;
            }

            this.visible = false;
        },
        fetchCompanies() {
            this.loading = true;

            axios
                .get(this.companySelectorUrl, {
                    headers: { Accept: "application/json" },
                })
                .then((response) => {
                    this.companies = response.data.companies || [];
                    this.activeCompanyId = response.data.activeCompanyId || null;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        selectCompany(company) {
            if (this.switching || company.id === this.activeCompanyId) {
                return;
            }

            this.switching = true;

            axios
                .post(
                    this.companySelectorSwitchUrl,
                    { company_id: company.id },
                    { headers: { Accept: "application/json" } }
                )
                .then(() => {
                    window.location.reload();
                })
                .finally(() => {
                    this.switching = false;
                });
        },
    },
};
</script>
